import ReactMarkdown from 'react-markdown';
import RemarkGfm from 'remark-gfm';

import { Container } from '../components/container/container';
import { Heading } from '../components/heading/heading';
import { Content, Copy } from '../components/register-screens/shared';
import { GROUP_OF_COMPANIES_MD } from '../data/markdown/group-of-companies';

export function ContractingGroup() {
  return (
    <Container>
      <Content>
        <Heading center>Sotheby&lsquo;s Group of Companies</Heading>
        <Copy>
          <ReactMarkdown remarkPlugins={[RemarkGfm]}>
            {GROUP_OF_COMPANIES_MD}
          </ReactMarkdown>
        </Copy>
      </Content>
    </Container>
  );
}
